export default __webpack_public_path__ + "assets/b7b1a416ad1e28dbb55b7ddf22507e02.png";